import {useEffect, useMemo, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";

import {useDispatch} from "react-redux";

import {currencyFormat, ploorPricePoint, priceFormat} from "../../../utils/helpers";



const ItemCouponComponent = ({data,index,useCouponModal,openModalScanOffline}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    let adminPay = data?.admin_id

    let typeCoupon = data.coupon.coupon_type
    let imgBackgroundCoupon = ''
    let icon = ''
    let title1=''
    let title2=''
    switch (typeCoupon) {
        case 'PLAYMOONGU': {
            imgBackgroundCoupon = "/images/img_coupon04.svg";
            icon = '/images/guya_big.svg';
            title1 = '문구야놀자 쿠폰'
            title2 = ''
            break;
        }
        case 'KIOSK_PHOTO': {
            imgBackgroundCoupon = "/images/img_coupon01.svg";
            icon = '/images/icon_coupon03.svg';
            title1 = '오프라인'
            title2 = '1회 무료 촬영권'
            break;
        }
        case 'VIDEO_MSG': {
            imgBackgroundCoupon = "/images/img_coupon03_1.svg";
            icon = '/images/icon_coupon02.svg';
            title1 = '영상편지'
            title2 = '무료 1회권'
            break;
        }
        default: imgBackgroundCoupon = "/images/img_coupon03_1.svg";
            icon = '/images/icon_coupon02.svg';
            title1 = '영상편지'
            title2 = '무료 1회권'
    }
    if(adminPay) {
        imgBackgroundCoupon = '/images/img_coupon02_update.svg'
        title2 = '1회 무료 쿠폰'
    }


    // console.log(data, 'props123',index)
    const useCouponModalFunction = (item) => {
        useCouponModal(item)
    }
    const setOpenModalScanOffline = () => {
        openModalScanOffline(data)
    }
    const chooseCoupon = () => {
      if(data.coupon.coupon_type != 'KIOSK_PHOTO'){
          useCouponModalFunction(data)
      }else {
          setOpenModalScanOffline()
      }
    }

    const RenderItem = () => {
        console.log(70, data.coupon);
        return (<div className="coupon-card" key={index} onClick={()=>chooseCoupon()}>
            <img className="coupon-card__bgr h-100" src={imgBackgroundCoupon} />
            <div className="coupon-card__content">
                <img className="coupon-card__content__icon" src={icon} />
                <div className={`coupon-card__content__text ${typeCoupon == 'PLAYMOONGU' ? ' coupon-type-playmoongu' : ''}`}>
                    <label className="coupon-card-text-title">
                        {title1}
                        <br/>
                        {title2}
                    </label>
                    {typeCoupon == 'PLAYMOONGU' ? (<label className="coupon-card-price">
                        {priceFormat(data.coupon.point)}원
                    </label>) : ''}
                    <label className="coupon-card-text-description m-0">유효기간 :
                        {data.expired_at ? data.expired_at : '무제한'}
                    </label>
                </div>
            </div>
            {typeCoupon != 'KIOSK_PHOTO' && typeCoupon != 'PLAYMOONGU' ? (<div className="coupon-card__user-purchase">
                <label className="m-0 d-block">{adminPay ? '관리자 지급' : '사용자 구매'}</label>
            </div>) : ''}
            {typeCoupon == 'PLAYMOONGU' ? (<div className="coupon-card__render-qrcode">
                <img className="coupon-card__render-qrcode_icon" src="/images/scan_barcode_w.svg"/>
            </div>) : ''}
            {typeCoupon == 'KIOSK_PHOTO' ? (<div className="coupon-card__render-qrcode">
                <img className="coupon-card__render-qrcode_icon" src="/images/icon_qr_mini.svg"/>
            </div>) : ''}
        </div>)
    }

    return (

        <>
            {RenderItem()}
        </>
    );
};

export default ItemCouponComponent;
